import { ORG_OVERRIDE_HEADER } from '#shared/organizations/orgOverride'
import { getStoredOrgOverride } from '~/utils/orgOverride'

export function useAuthFetch() {
  const { getToken } = useAuth()
  const { handleResponseError } = useUsageLimit()

  async function authFetch(url: string, opts: RequestInit = {}): Promise<Response> {
    // Prefer Office token when running inside Word
    const { $officeToken } = useNuxtApp()
    const token = $officeToken?.value || await getToken()

    const headers = Object.fromEntries(new Headers(opts.headers || {}).entries())
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
    // Kept in step with `app/plugins/api.ts` and `useApi().apiStreamFetch` (MAR-957): chat streaming
    // and the workflow `/draft` confirm go through here, and dropping the super-admin override would
    // silently answer from the super-admin's OWN organization while the banner said otherwise
    // (MAR-427). `getStoredOrgOverride` is client-only, so SSR never sends it.
    const orgOverride = getStoredOrgOverride()
    if (orgOverride) headers[ORG_OVERRIDE_HEADER] = orgOverride
    const response = await fetch(url, { ...opts, headers })
    if (response.status === 429) {
      const body = await response.clone().json().catch(() => null)
      handleResponseError(429, body?.data ?? body)
    }
    return response
  }

  return { authFetch, getToken }
}
